/**
 * Anonymous `/public/*` routes (the public offer page and its unit detail
 * screen) never carry a session. Both the router-level auth guard
 * (`__root.tsx`'s `handleRootAuthGuard`/`RootComponent`) and the fetch-level
 * 401 guard (`auth-client.ts`'s `redirectToLoginIfTokenExpired`) need to
 * recognize the same set of paths — kept as one helper so the prefix can't
 * silently diverge between the two gates.
 */
export function isPublicRoutePath(pathname: string): boolean {
  return pathname.startsWith('/public');
}
